import request from "@/utils/request";
// 店铺列表
export function getShopList(params) {
	return request({
		url:'/oms/goods/shop/list',
		method:'GET',
		params:params
	})
}

// 店铺分布
export function getShopPieData(data) {
	return request({
		url:'/oms/goods/report/shopGoodsCnt',
		method:'POST',
		data
	})
}

// 类目分布
export function getCategoryPieData(data) {
	return request({
		url:'/oms/goods/report/catGoodsCnt',
		method:'POST',
		data
	})
}

// 类目分布
export function getGoodsSalesReportList(data) {
	return request({
		url:'/oms/goods/report/detail/list',
		method:'POST',
		data
	})
}

// 买手排行
/*export function getBuyerSaleData(data) {
	return request({
		url:'/oms/goods/report/buyerSale',
		method:'POST',
		data
	})
}*/

// 买手30日销量类目分布
export function getBuyer30SaleData(data) {
	return request({
		url: '/oms/goods/report/buyerCatCnt',
		method: 'POST',
		data
	})
}



// WEBPACK FOOTER //
// ./src/api/scm/goods-sales-report.js